<template>
  <div class="modal grey700">
    <v-row
      no-gutters
      class="fill-height"
      :class="{'flex-column': $vuetify.breakpoint.smAndDown}"
    >
      <!-- sidebar -->
      <v-col class="menu-sidebar d-flex align-center">
        <div class="full-width">
          <v-tabs
            v-model="tab"
            :vertical="$vuetify.breakpoint.mdAndUp"
            background-color="transparent"
            color="grey100"
            class="pl-3 flex-shrink-1"
            active-class="primary800"
            hide-slider
          >
            <v-tab v-t="'page.account.account'" class="justify-end text-h6" :ripple="false" />
            <v-tab v-t="'page.account.affiliates'" class="justify-end text-h6" :ripple="false" />
            <v-tab v-t="'page.account.settings'" class="justify-end text-h6" :ripple="false" />
            <v-tab v-t="'page.account.bets'" class="justify-end text-h6" :ripple="false" />
            <v-tab v-t="'page.account.transactions'" class="justify-end text-h6" :ripple="false" />
            <v-tab class="justify-end text-h6" :ripple="false">
              <fai
                v-if="pendingTrades.length"
                :icon="['fas', 'circle']"
                class="blue400--text text-body-1 mr-2 trade-status"
              />
              <span v-t="'page.account.trades'" />
            </v-tab>
          </v-tabs>
          <v-tab
            class="d-none d-md-flex justify-end text-h6 font-weight-bold text--secondary mt-2" :ripple="false" target="_blank"
            rel="noopener noreferrer"
            href="https://banditcamp.tawk.help/"
          >
            <span v-t="'page.account.support'" />
            <fai :icon="['fad', 'external-link-square-alt']" class="ml-2 mb-1 text-body-1" />
          </v-tab>
        </div>
      </v-col>

      <v-col class="content-ctn pa-8">
        <v-tabs-items v-model="tab">
          <v-tab-item :transition="false" :reverse-transition="false">
            <Account @close="close" />
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false">
            <Affiliates />
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false">
            <Settings />
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false">
            <BetsHistory />
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false">
            <TransactionHistory />
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false">
            <Trades />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Settings from './views/settings'
import Account from './views/account'
import BetsHistory from './views/bets'
import TransactionHistory from './views/transactions'
import Trades from './views/trades'

const TABS = {
  account: 0,
  affiliates: 1,
  settings: 2,
  bets: 3,
  transactions: 4,
  trades: 5,
}

export default {
  components: {
    Settings,
    Affiliates: () => import('./views/affiliates'),
    Account,
    BetsHistory,
    TransactionHistory,
    Trades,
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tab: 0,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
      pendingTrades: 'user/pendingTrades',
    }),
  },
  created() {
    if (this.payload?.tab) {
      this.tab = TABS[this.payload.tab] ?? 0
    }
  },
}
</script>

<style lang="scss" scoped>

.modal {
  height: 80vh;
  min-height: 300px;
  max-height: 760px;

  @include xs {
    height: 90vh;
    max-height: 100%;
  }
}

.menu-sidebar {
  max-width: 230px;
  background-color: desaturate(primary(700), 10%);

  @include xs {
    max-width: 100%;
    flex-grow: 0;
  }

  @include sm {
    max-width: 100%;
    flex-grow: 0;
  }
}

.v-tabs {
  flex-grow: 1;
  overflow: hidden;

  ::v-deep .v-slide-group__prev {
    display: none !important;
  }

  .v-tab {
    justify-content: flex-start;
    font-weight: bold;

    @include xs {
      font-size: 14px !important;
    }
  }
}

.trade-status {
  animation: pulse 0.2s ease-in-out alternate infinite;
}

@keyframes pulse {
  from {
    opacity: 1;
  }

  to {
    opacity: 0.5;
  }
}

.content-ctn {
  overflow-y: auto;
  min-width: 0;
  height: 100%;
  flex: 1;
}

.v-tabs-items {
  background: transparent !important;
}

.user-avatar {
  transform: translate;
}

</style>
